import { Locker } from "../data/LockerDataTypes";
import { IFilter } from "../data/Filter";

export class FilterByPos implements IFilter{
    value:any;
    
    IsApplicable() : boolean {
        return this.value===true;
    };

    Run(lockers: Locker[]): Locker[] {
        return (lockers.filter(x => x.supportedPayment === 1) || []) as Locker[];
    };

    Clear():void{
        this.value=false;
    }
}